import React from 'react';
import { string } from 'prop-types';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes, LINE_ITEM_PROVIDER_COMMISSION } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
const { Money } = sdkTypes;

import css from './OrderBreakdown.module.css';

const LineItemProviderCommissionRefundMaybe = props => {
  const { lineItems, isProvider, marketplaceName, intl } = props;

  const refund = lineItems.find(
    item => item.code === LINE_ITEM_PROVIDER_COMMISSION && item.reversal
  );

  if(!(isProvider && refund)){
    return null;
  }

  const deliveryLineItem = lineItems.filter((st)=> st.code=="line-item/shipping-fee");
    const deliveryLinePrice = deliveryLineItem.length ? deliveryLineItem[0].lineTotal.amount : 0;
      const marketPlaceCurrency =  refund.lineTotal.currency || "USD";
      const providerCommissionAmount = refund.lineTotal.amount;

      const commission = new Money(providerCommissionAmount - deliveryLinePrice,marketPlaceCurrency);

      const formattedCommission = commission ? formatMoney(intl, commission) : null;


  return  (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.refundProviderFee" values={{ marketplaceName }} />
      </span>
      <span className={css.itemValue}>{formattedCommission}</span>
    </div>
  );
};

LineItemProviderCommissionRefundMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  marketplaceName: string.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemProviderCommissionRefundMaybe;
